import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=4d799bbb&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports